
import { Box } from '@mui/material';
import Chart from "react-apexcharts";
import { memo, useEffect } from 'react';
import React from 'react';
import moment from 'moment';
import StudyCompleteness from '../../studyCompleteness/StudyCompleteness';

const DocumentMetricComponent = (props: any) => {
    const TICK_AMOUNT = 5;
    const { categories, series, maxValue } = props;
    const [optionsData, setOptionsData] = React.useState<any>({});

    const studyCompleteness = new StudyCompleteness();

    const updateChart = () => {
        const chartOptionsWithCategories = getChartOptions();
        setOptionsData(chartOptionsWithCategories);
    }

    const getChartOptions = () => {
        return {
            chart: {
                type: 'bar', height: 250, stacked: true,
                // stackType: '100%',
                toolbar: {
                    show: false
                },
                zoom: {
                    enabled: true
                },
                animations: {
                    enabled: false
                }
            },
            noData: {
                text: "No data",
                align: 'center',
                verticalAlign: 'middle',
                offsetX: 0,
                offsetY: 0,
                style: {
                    fontSize: '14px',
                }
            },
            colors: studyCompleteness.getColorCodes(),
            responsive: [
                {
                    breakpoint: 480, options: {
                        legend: { display: false }
                    }
                }],
            plotOptions: {
                bar: { horizontal: false, columnWidth: '40px' },
            },
            dataLabels: {
                enabled: false
            },
            xaxis: {
                type: 'category',
                labels: {
                    formatter: function (value: any) {
                        return moment(value).format("MMM");
                    }
                },
                categories: (categories && categories?.length > 0) ? categories : [moment().format("MM")]
            },
            yaxis: {
                tickAmount: TICK_AMOUNT,
                min: 0,
                max: maxValue,
                forceNiceScale: true,
                floating: false,
                labels: {
                    formatter: function (val: any) {
                        return val?.toFixed(0);
                    }
                }
            },
            legend: {
                show: false
                
            },
            fill: {
                opacity: 1
            }
        };
    }

    useEffect(() => {
        updateChart();
    }, [categories, series, maxValue]);

    return (
        <Box className='roundBorderedBox eqHeightFlex' sx={{ p: 2, flexGrow: 1, height: '100%' }}>
            <h4 className='verticalTitle'>Document Count</h4>
            <Box sx={{ flexGrow: 1 }} className="barGraphArea">
                {/* <span className='title'>Document Status over Time</span> */}
                <br />
                <Chart options={optionsData} series={series} type="bar" height={250} />
            </Box>
        </Box>
    )
};
export default memo(DocumentMetricComponent);
